import React, { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, MenuItem, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../../context";

export default function AssignmentFormDialog({ open, onClose, assignment, seminars, onSave }) {
  const { t } = useTranslation();
  const auth = useAuth();
  const currentUserId = auth?.user?.user?.id;
  const [form, setForm] = useState({ seminar: "", title: "", description: "", due_date: "" });

  useEffect(() => {
    if (assignment) {
      setForm({
        seminar: assignment.seminar ?? "",
        title: assignment.title || "",
        description: assignment.description || "",
        due_date: assignment.due_date ? assignment.due_date.slice(0, 10) : "",
      });
    } else {
      setForm({ seminar: "", title: "", description: "", due_date: "" });
    }
  }, [assignment, open]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = {
      seminar: form.seminar ? Number(form.seminar) : null,
      title: form.title || "",
      description: form.description || "",
      due_date: form.due_date || null,
    };
    if (currentUserId) payload.created_by = currentUserId;
    onSave(payload);
  };

  const seminarList = seminars?.results ?? seminars ?? [];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{assignment ? t("academic.editAssignment", "Edit assignment") : t("academic.addAssignment", "Add assignment")}</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 0.5 }}>
            <Grid item xs={12}>
              <TextField fullWidth required name="seminar" select label={t("academic.seminar", "Seminar")} value={form.seminar} onChange={handleChange} size="small">
                <MenuItem value="">—</MenuItem>
                {seminarList.map((s) => (
                  <MenuItem key={s.id} value={s.id}>{s.title} ({s.seminar_date})</MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth required name="title" label={t("academic.assignmentTitle", "Title")} value={form.title} onChange={handleChange} size="small" />
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth name="description" label={t("academic.description", "Description")} value={form.description} onChange={handleChange} multiline rows={3} size="small" />
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth name="due_date" type="date" label={t("academic.dueDate", "Due date")} value={form.due_date} onChange={handleChange} InputLabelProps={{ shrink: true }} size="small" />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>{t("common.cancel", "Cancel")}</Button>
          <Button type="submit" variant="contained" disabled={!form.seminar || !form.title}>{t("common.save", "Save")}</Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
